import React, { useEffect, useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import { PrimaryButton, SecondaryButton } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import { ImportService } from "@prestosports/prestostats-core/Services";
import PlayerImportRow from "./PlayerImportRow";
import teamImportStyles from "../../common/styles/sports/TeamImport.Styles";
import commonStyles from "../../common/styles/Common.styles";
import { useSportContext } from "../../../state/sport/context";

const TeamImport = ({
	teamId,
	importedPlayers = [],
	players = [],
	onSave = () => {},
	onCancel = () => {},
	onDeletePlayer = () => {},
	isImporting = false
}) => {
	const classes = teamImportStyles();
	const commonClasses = commonStyles();
	const [importedRecords, setImportedRecords] = useState(importedPlayers);

	const { state: sportState } = useSportContext();
	const years = sportState.allowedYears();

	const handleChange = async (record) => {
		await ImportService.validatePlayer(teamId, importedRecords, record);
		setImportedRecords(
			importedRecords.map((ir) =>
				ir.importIndex === record.importIndex ? record : ir
			)
		);
	};

	const isValid = () => {
		return (
			importedRecords.length &&
			importedRecords.every((r) => !Object.values(r.errors).length)
		);
	};

	useEffect(() => {
		setImportedRecords(importedPlayers);
	}, [importedPlayers]);

	return (
		<Box className={commonClasses.boxContainer}>
			<TableContainer className={commonClasses.centerContainer}>
				<Table aria-label="import" size="small">
					<TableHead>
						<TableRow className={classes.tableHead}>
							<TableCell className={classes.md3}>Incoming Player</TableCell>
							<TableCell className={classes.md1}>Year</TableCell>
							<TableCell className={classes.md1}>Number</TableCell>
							<TableCell className={classes.md1}>National Ranking</TableCell>
							<TableCell className={classes.md1}>Regional Ranking</TableCell>
							<TableCell className={classes.md1}>Conference Ranking</TableCell>
							<TableCell className={classes.md1}>Starter</TableCell>
							<TableCell className={classes.md1}>Single</TableCell>
							<TableCell className={classes.md1}>Doubles</TableCell>
							<TableCell className={classes.md3}>Existing Player</TableCell>
							<TableCell className={classes.md1} />
						</TableRow>
					</TableHead>
					<TableBody>
						{importedRecords.map((p) => (
							<PlayerImportRow
								key={p.importIndex}
								player={p}
								years={years}
								teamPlayers={players}
								onChange={handleChange}
								onPlayerDelete={onDeletePlayer}
							/>
						))}
					</TableBody>
				</Table>
			</TableContainer>

			<Toolbar className={commonClasses.actionToolbar}>
				<Grid container direction="row" justifyContent="flex-end" spacing={2}>
					<Grid item>
						<SecondaryButton color="secondary" label="Cancel" onClick={onCancel} />
					</Grid>
					<Grid item>
						<PrimaryButton
							disabled={!isValid() || isImporting}
							color="primary"
							label="Save"
							onClick={() => onSave(importedRecords)}
						/>
					</Grid>
				</Grid>
			</Toolbar>
		</Box>
	);
};

export default TeamImport;
